import { render, staticRenderFns } from "./activeManager.vue?vue&type=template&id=4b418a8b&scoped=true"
import script from "./activeManager.vue?vue&type=script&lang=js"
export * from "./activeManager.vue?vue&type=script&lang=js"
import style0 from "./activeManager.vue?vue&type=style&index=0&id=4b418a8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b418a8b",
  null
  
)

export default component.exports